import React from "react";
import logo from "../../../../../assets/Photography/lense.jpeg"

const HorizontalScroll = () => {
  return (
    <div>
    <div className="media-display-layout">
      <div style={{display: "flex", flexDirection: "column", width: "100%", height: "80%"}}>
        {logo && <img src={logo} alt="Logo" className="st-profile-logo"style={{width: "100%", height: "100%"}}/>}
      </div>
      <div style={{display: "flex", flexDirection: "row", width: "100%", height: "20%", background: "purple"}}>
          <div style={{width: "50%", height: "100%", background: "red"}}></div>
          <div style={{width: "50%", height: "100%", background: "green"}}></div>
      </div>
    </div>
      <div className="horizontal-scroll" style={{color: "darkgray"}}>➡️ Horizontal Scroll Gallery</div>
    </div>
  );
};

export default HorizontalScroll;
